import get from 'lodash/get';
import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}, action = {}) {
  let pageType = 'list';
  if (get(action, 'type') === 'WCI_HUB_PAGE_LOADED') {
    pageType = 'lander';
  }
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const airtableData =
    action?.worldChangingIdeasPage?.metadata?.records?.[0]?.fields ||
    action?.worldChangingIdeasPage?.data?.Metadata?.[0] ||
    {};
  const canonicalList2026 = 'https://www.fastcompany.com/world-changing-ideas/list';
  const canonicalLander2026 = 'https://www.fastcompany.com/world-changing-ideas';
  const canonical = pageType === 'lander' ? canonicalLander2026 : canonicalList2026;
  const titleLander2026 =
    '2026 World Changing Ideas: 191 projects making a difference';
  const titleList2026 = '191 World Changing Ideas for 2026';
  const title2026 = pageType === 'lander' ? titleLander2026 : titleList2026;
  const descriptionLander2026 =
    "Fast Company's 2026 World Changing Ideas list recognizes nearly 200 projects driving change across a multitude of industries.";
  const descriptionList2026 =
    'Meet the nearly 200 projects—and four visionary leaders—that are tackling the biggest problems across industries with creativity and dedication to improving the world.';
  const description2026 =
    pageType === 'lander' ? descriptionLander2026 : descriptionList2026;
  const img2026 =
    'https://images.fastcompany.com/image/upload/f_webp,q_auto,c_fit/wp-cms-2/2026/06/1920x1080-Social-Share-for-Lander.jpg';
  const wpTitle = get(action, 'worldChangingIdeasPage.title.rendered');
  const img =
    img2026 ||
    airtableData?.['SEO image'] ||
    airtableData?.OGImage ||
    get(
      action,
      'worldChangingIdeasPage._embedded.wp:featuredmedia[0].source_url'
    );
  const wpExcerpt =
    get(action, 'worldChangingIdeasPage.acf.seoDescription') ||
    get(action, 'worldChangingIdeasPage.excerpt.rendered');
  const socialTitle =
    title2026 ||
    airtableData?.OGheadline ||
    airtableData?.PageTitle ||
    (wpTitle ? striptags(wpTitle).trim() : ''); // displays for twitter and social platforms
  const seoTitle =
    title2026 ||
    airtableData?.SEOTitle ||
    airtableData?.SEOtitle ||
    get(action, 'worldChangingIdeasPage.acf.title') ||
    get(action, 'worldChangingIdeasPage.title.rendered'); // displays on google and browser tab
  const twitterDescription =
    description2026 || airtableData?.twitterDescription;
  const description =
    description2026 ||
    airtableData?.metaDescription ||
    (wpExcerpt ? striptags(wpExcerpt).trim() : '');
  const socialDescription =
    description2026 || airtableData?.OGdescription || description;
  const url =
    airtableData?.PageUrl ||
    get(action, 'worldChangingIdeasPage.acf.publicUrl');

  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle,
    overrideTitle: true,
    canonical,
    url: canonical || url,
    description,
    socialDescriptionOverride: socialDescription,
    twitterDescription,
    image: img,
    articleSection: 'World Changing Ideas',
    config: get(state, 'config'),
    facebookTitleOverride: socialTitle,
    twitterTitleOverride: socialTitle
  });
}
